import React, { FC, useEffect, useMemo, useRef, useState } from "react"
import { Trans, useTranslation } from "react-i18next"

import { UText } from "../../../components"
import { Box, Button, Divider, Grid } from "../../../components/mui.components"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { setData } from "@/core/app/slices/patients/patientSlice"
const ScannerBox: FC = ({
  scannerObjData,
  isDivider,
  setDeleteStorageObj,
  setOpenDisconnectPopup,
}) => {
  const { t } = useTranslation("common")

  const dispatch = useAppDispatch()

  return (
    <Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: "8px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <UText
            variant={"h6"}
            component={"div"}
            sxProp={{ textAlign: "center", marginRight: "8px" }}
          >
            {`${scannerObjData.name}`}
          </UText>
          {scannerObjData.isPrimary ? (
            <Box
              sx={{
                width: "72px",
                height: "24px",
                padding: "3px 4px",
                background: "#215ECD",
                borderRadius: "100px",
                color: "#fff",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >{`Primary`}</Box>
          ) : (
            <Button
              variant={"text"}
              sx={{
                minWidth: "auto",
                height: "auto",
                width: "auto",
                lineHeight: "22px",
                py: "4px",
                px: "5px",
              }}
              onClick={() => {
                const { localName } = scannerObjData
                const shapeLocal = localStorage.getItem("3shapeData")
                const meditLocal = localStorage.getItem("meditData")
                const alliesLocal = localStorage.getItem("alliesData")
                if (localName === "3shapeData") {
                  const obj = JSON.parse(shapeLocal)
                  obj.isPrimary = true
                  localStorage.setItem(localName, JSON.stringify(obj))

                  if (meditLocal) {
                    const meditObj = JSON.parse(meditLocal)
                    meditObj.isPrimary = false
                    localStorage.setItem("meditData", JSON.stringify(meditObj))
                  }
                  if (alliesLocal) {
                    const alliesObj = JSON.parse(alliesLocal)
                    alliesObj.isPrimary = false
                    localStorage.setItem(
                      "alliesData",
                      JSON.stringify(alliesObj),
                    )
                  }
                }
                if (localName === "meditData") {
                  const obj = JSON.parse(meditLocal)
                  obj.isPrimary = true
                  localStorage.setItem(localName, JSON.stringify(obj))

                  if (shapeLocal) {
                    const shapeObj = JSON.parse(shapeLocal)
                    shapeObj.isPrimary = false
                    localStorage.setItem("3shapeData", JSON.stringify(shapeObj))
                  }
                  if (alliesLocal) {
                    const alliesObj = JSON.parse(alliesLocal)
                    alliesObj.isPrimary = false
                    localStorage.setItem(
                      "alliesData",
                      JSON.stringify(alliesObj),
                    )
                  }
                }
                if (localName === "alliesData") {
                  const obj = JSON.parse(alliesLocal)
                  obj.isPrimary = true
                  localStorage.setItem(localName, JSON.stringify(obj))
                  if (shapeLocal) {
                    const shapeObj = JSON.parse(shapeLocal)
                    shapeObj.isPrimary = false
                    localStorage.setItem("3shapeData", JSON.stringify(shapeObj))
                  }
                  if (meditLocal) {
                    const meditObj = JSON.parse(meditLocal)
                    meditObj.isPrimary = false
                    localStorage.setItem("meditData", JSON.stringify(meditObj))
                  }
                }
                // clear caseListFor3Shape\ scannerCaseListCount\ scannerSelect
                dispatch(
                  setData({
                    scannerSelect: "",
                    caseListFor3Shape: [],
                    scannerCaseListCount: 0,
                  }),
                )
              }}
            >
              {`Make Primary`}
            </Button>
          )}
        </Box>
        <Button
          variant={"text"}
          sx={{
            minWidth: "auto",
            height: "auto",
            width: "auto",
            lineHeight: "22px",
            py: "4px",
            px: "5px",
          }}
          onClick={() => {
            setDeleteStorageObj(scannerObjData)
            setOpenDisconnectPopup(true)
          }}
        >
          {`DISCONNECT`}
        </Button>
      </Box>
      <Grid>
        <UText
          variant={"body1"}
          component={"div"}
          sxProp={{ pb: 1, color: "rgba(0,0,0,0.6)" }}
        >
          {`Status`}
        </UText>
        <Box sx={{ display: "flex" }}>
          <UText
            variant={"body1"}
            component={"div"}
            sxProp={{ pb: 1, pr: 0.5 }}
          >
            {`Connected`}
          </UText>
          <CheckCircleIcon color="success" />
        </Box>
      </Grid>
      {isDivider && <Divider sx={{ my: 2 }} />}
    </Grid>
  )
}

export default ScannerBox
